// src/components/BoardOfEd/components/Program2400.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_2400_CONFIG = {
  fullName: "TRANSPORTATION",
  docId: "2400",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsSupervision",
      label: "Positions – Supervision",
      valueType: "count",
      sources: [{ block: "Positions", key: "Supervision" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSecretarial",
      label: "Positions – Secretarial",
      valueType: "count",
      sources: [{ block: "Positions", key: "Secretarial" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsBusYardPersonnel",
      label: "Positions – Bus Yard Personnel",
      valueType: "count",
      sources: [{ block: "Positions", key: "Bus Yard Personnel" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesSupervision",
      label: "Salaries – Supervision",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Supervision" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecretarial",
      label: "Salaries – Secretarial",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Secretarial" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesDayRateDrivers",
      label: "Salaries – Day Rate Drivers",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Day Rate Drivers" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesMiscDriverActivities",
      label: "Salaries – Misc. Driver Activities",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Misc. Driver Activities" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesOvertime",
      label: "Salaries – Overtime",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Overtime" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSchoolCrossingGuards",
      label: "Salaries – School Crossing Guards",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "School Crossing Guards" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesInServiceTraining",
      label: "Salaries – In-Service Training",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "In-Service Training" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesBusYardPersonnel",
      label: "Salaries – Bus Yard Personnel",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Bus Yard Personnel" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesMagnetSchoolDrivers",
      label: "Salaries – Magnet School Drivers",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Magnet School Drivers" }],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "servicesVehicleRental",
      label: "Vehicle Rental",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Vehicle Rental" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "servicesMedicalAdvisor",
      label: "Medical Advisor",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Medical Advisor" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "servicesPupilBusSafetyEduc",
      label: "Pupil/Bus Safety Educ.",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Pupil/Bus Safety Educ." }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "servicesRepairsParts",
      label: "Repairs/Parts",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Repairs/Parts" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "servicesMagnetVehRental",
      label: "Magnet School Veh. Rental",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Magnet School Veh. Rental" },
      ],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "servicesInsuranceVehicle",
      label: "Insurance/Vehicle",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Insurance/Vehicle" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "servicesContractedTraining",
      label: "Contracted Training",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Contracted Training" }],
      group: "services",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "materialsFuel",
      label: "Fuel",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Fuel" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "materialsMagnetFuel",
      label: "Magnet School Fuel",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Magnet School Fuel" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "materialsLubricants",
      label: "Lubricants",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Lubricants" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "materialsTiresTubes",
      label: "Tires/Tubes",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Tires/Tubes" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "materialsSuppliesUniforms",
      label: "Supplies/Uniforms",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Supplies/Uniforms" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "materialsPublications",
      label: "Publications",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Publications" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "materialsTechnologySoftware",
      label: "Technology – Software",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Technology - Software" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "otherTravel",
      label: "Travel",
      valueType: "currency",
      sources: [{ block: "Other", key: "Travel" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "otherDuesFees",
      label: "Dues/Fees",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Dues/Fees" },
        { block: "Other", key: "Dues and Fees" },
      ],
      group: "other",
      defaultVisible: false,
    },

    // EQUIPMENT
    {
      key: "equipmentNew",
      label: "Equipment – New",
      valueType: "currency",
      sources: [{ block: "Equipment", key: "New" }],
      group: "equipment",
      defaultVisible: false,
    },
    {
      key: "equipmentReplacement",
      label: "Equipment – Replacement",
      valueType: "currency",
      sources: [{ block: "Equipment", key: "Replacement" }],
      group: "equipment",
      defaultVisible: false,
    },

    // OFFSETS
    {
  key: "offsetMagnetSchool",
  label: "Offset – Magnet School Offset",
  valueType: "currency",
  sources: [
    { block: "Offset", key: "Magnet School Offset" },
    { block: "Offsets", key: "Magnet School Offset" }, // just in case
  ],
  group: "offsets",
  defaultVisible: false,
}
  ],

  tables: [
    {
      id: "approvedMain",
      title: "2400 TRANSPORTATION – Approved",
      sectionKey: "Approved",
      fields: [
        // Positions
        "positionsSupervision",
        "positionsSecretarial",
        "positionsBusYardPersonnel",

        // Salaries
        "salariesSupervision",
        "salariesSecretarial",
        "salariesDayRateDrivers",
        "salariesMiscDriverActivities",
        "salariesOvertime",
        "salariesSchoolCrossingGuards",
        "salariesInServiceTraining",
        "salariesBusYardPersonnel",
        "salariesMagnetSchoolDrivers",

        // Purchased Services
        "servicesVehicleRental",
        "servicesMedicalAdvisor",
        "servicesPupilBusSafetyEduc",
        "servicesRepairsParts",
        "servicesMagnetVehRental",
        "servicesInsuranceVehicle",
        "servicesContractedTraining",

        // Supplies / Materials
        "materialsFuel",
        "materialsMagnetFuel",
        "materialsLubricants",
        "materialsTiresTubes",
        "materialsSuppliesUniforms",
        "materialsPublications",
        "materialsTechnologySoftware",

        // Other
        "otherTravel",
        "otherDuesFees",

        // Equipment
        "equipmentNew",
        "equipmentReplacement",

        // OFFSETS
        "offsetMagnetSchool",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsSupervision: { minWidth: "120px" },
        positionsSecretarial: { minWidth: "120px" },
        positionsBusYardPersonnel: { minWidth: "140px" },

        // Salaries
        salariesSupervision: { minWidth: "120px" },
        salariesSecretarial: { minWidth: "120px" },
        salariesDayRateDrivers: { minWidth: "120px" },
        salariesMiscDriverActivities: { minWidth: "140px" },
        salariesOvertime: { minWidth: "90px" },
        salariesSchoolCrossingGuards: { minWidth: "140px" },
        salariesInServiceTraining: { minWidth: "140px" },
        salariesBusYardPersonnel: { minWidth: "140px" },
        salariesMagnetSchoolDrivers: { minWidth: "140px" },

        // Services
        servicesVehicleRental: { minWidth: "100px" },
        servicesMedicalAdvisor: { minWidth: "100px" },
        servicesPupilBusSafetyEduc: { minWidth: "120px" },
        servicesRepairsParts: { minWidth: "100px" },
        servicesMagnetVehRental: { minWidth: "120px" },
        servicesInsuranceVehicle: { minWidth: "100px" },
        servicesContractedTraining: { minWidth: "100px" },

        // Materials
        materialsFuel: { minWidth: "110px" },
        materialsMagnetFuel: { minWidth: "110px" },
        materialsLubricants: { minWidth: "100px" },
        materialsTiresTubes: { minWidth: "100px" },
        materialsSuppliesUniforms: { minWidth: "100px" },
        materialsPublications: { minWidth: "90px" },
        materialsTechnologySoftware: { minWidth: "100px" },

        // Other
        otherTravel: { minWidth: "100px" },
        otherDuesFees: { minWidth: "90px" },

        // Equipment
        equipmentNew: { minWidth: "140px" },
        equipmentReplacement: { minWidth: "170px" },
        offsetMagnetSchool: { minWidth: "150px" },
      },
    },
    {
      id: "actualMain",
      title: "2400 TRANSPORTATION – Actual",
      sectionKey: "Actual",
      fields: [
        // Positions
        "positionsSupervision",
        "positionsSecretarial",
        "positionsBusYardPersonnel",

        // Salaries
        "salariesSupervision",
        "salariesSecretarial",
        "salariesDayRateDrivers",
        "salariesMiscDriverActivities",
        "salariesOvertime",
        "salariesSchoolCrossingGuards",
        "salariesInServiceTraining",
        "salariesBusYardPersonnel",
        "salariesMagnetSchoolDrivers",

        // Purchased Services
        "servicesVehicleRental",
        "servicesMedicalAdvisor",
        "servicesPupilBusSafetyEduc",
        "servicesRepairsParts",
        "servicesMagnetVehRental",
        "servicesInsuranceVehicle",
        "servicesContractedTraining",

        // Supplies / Materials
        "materialsFuel",
        "materialsMagnetFuel",
        "materialsLubricants",
        "materialsTiresTubes",
        "materialsSuppliesUniforms",
        "materialsPublications",
        "materialsTechnologySoftware",

        // Other
        "otherTravel",
        "otherDuesFees",

        // Equipment
        "equipmentNew",
        "equipmentReplacement",

        // OFFSETS
        "offsetMagnetSchool",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // reuse same widths
        positionsSupervision: { minWidth: "120px" },
        positionsSecretarial: { minWidth: "120px" },
        positionsBusYardPersonnel: { minWidth: "140px" },

        // Salaries
        salariesSupervision: { minWidth: "120px" },
        salariesSecretarial: { minWidth: "120px" },
        salariesDayRateDrivers: { minWidth: "120px" },
        salariesMiscDriverActivities: { minWidth: "140px" },
        salariesOvertime: { minWidth: "90px" },
        salariesSchoolCrossingGuards: { minWidth: "140px" },
        salariesInServiceTraining: { minWidth: "140px" },
        salariesBusYardPersonnel: { minWidth: "140px" },
        salariesMagnetSchoolDrivers: { minWidth: "140px" },

        // Services
        servicesVehicleRental: { minWidth: "100px" },
        servicesMedicalAdvisor: { minWidth: "100px" },
        servicesPupilBusSafetyEduc: { minWidth: "120px" },
        servicesRepairsParts: { minWidth: "100px" },
        servicesMagnetVehRental: { minWidth: "120px" },
        servicesInsuranceVehicle: { minWidth: "100px" },
        servicesContractedTraining: { minWidth: "100px" },

        materialsFuel: { minWidth: "110px" },
        materialsMagnetFuel: { minWidth: "170px" },
        materialsLubricants: { minWidth: "130px" },
        materialsTiresTubes: { minWidth: "130px" },
        materialsSuppliesUniforms: { minWidth: "160px" },
        materialsPublications: { minWidth: "130px" },
        materialsTechnologySoftware: { minWidth: "180px" },

        otherTravel: { minWidth: "110px" },
        otherDuesFees: { minWidth: "110px" },

        equipmentNew: { minWidth: "140px" },
        equipmentReplacement: { minWidth: "170px" },
        offsetMagnetSchool: { minWidth: "150px" },
      },
    },
  ],

  inflationSumFields: null,
};

export function Program2400(props) {
  return (
    <ProgramBudget programId="2400" config={PROGRAM_2400_CONFIG} {...props} />
  );
}
